import { render, staticRenderFns } from "./panel-facebook-settings.vue?vue&type=template&id=14cc29ef&"
import script from "./panel-facebook-settings.vue?vue&type=script&lang=js&"
export * from "./panel-facebook-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports